import { render, staticRenderFns } from "./QutaPartList.vue?vue&type=template&id=6a820f22&"
import script from "./QutaPartList.vue?vue&type=script&lang=js&"
export * from "./QutaPartList.vue?vue&type=script&lang=js&"
import style0 from "./QutaPartList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports